import type { ComponentType } from "react";
import { Home, Server, Dumbbell, TrendingUp } from "lucide-react";

export type Brand = {
  id: string;
  name: string;             // primary wordmark
  qualifier?: string;       // sub-line on the tile (e.g. "Roofing & Restoration")
  tagline: string;          // single-sentence summary
  description: string;      // 1–2 paragraphs for the body
  href: string;
  external: boolean;
  domainLabel: string;      // tile footer (e.g. BUILTBYWARD.COM)
  category: string;         // short eyebrow tag (Construction / Software / Fitness / Capital)
  icon: ComponentType<{ className?: string }>;
  wordmarkClass: "jw-wordmark" | "jw-wordmark-bronze";
};

// Only Jalen is intentionally NOT in this list — the public portal does not surface OJ.
// Order matches the brand artifact infographic.
export const BRANDS: Brand[] = [
  {
    id: "built-by-ward",
    name: "Built By Ward",
    qualifier: "Roofing & Restoration",
    category: "Construction",
    tagline: "Documented right. Insurance-ready.",
    description:
      "Founder-on-site roofing, restoration, and storm response in DFW. Every job photographed, every claim adjuster-ready.",
    href: "https://builtbyward.com",
    external: true,
    domainLabel: "BUILTBYWARD.COM",
    icon: Home,
    wordmarkClass: "jw-wordmark-bronze",
  },
  {
    id: "ward-tech",
    name: "Ward Tech Systems",
    qualifier: "Software",
    category: "Software",
    tagline: "Built by someone who actually knows the field.",
    description:
      "Custom portals and operations software for roofing, restoration, and service businesses that have outgrown spreadsheets and group texts.",
    href: "https://wardtechsystems.com",
    external: true,
    domainLabel: "WARDTECHSYSTEMS.COM",
    icon: Server,
    wordmarkClass: "jw-wordmark",
  },
  {
    id: "jay-ward-muscle",
    name: "Jay Ward Muscle",
    qualifier: "Fitness",
    category: "Fitness",
    tagline: "The system behind the body.",
    description:
      "6 ft athletic-classic build with documented cuts, recomps, and the daily systems that make the discipline repeatable.",
    href: "https://app.jalenward.com",
    external: true,
    domainLabel: "APP.JALENWARD.COM",
    icon: Dumbbell,
    wordmarkClass: "jw-wordmark",
  },
  {
    id: "ward-capital",
    name: "Ward Capital",
    qualifier: "Funding & Capital",
    category: "Capital",
    tagline: "Cash flow creates freedom.",
    description:
      "Fueling growth, acquisitions, and long-term wealth through strategic capital solutions for contractors and entrepreneurs.",
    href: "https://wardcapital.com",
    external: true,
    domainLabel: "WARDCAPITAL.COM",
    icon: TrendingUp,
    wordmarkClass: "jw-wordmark",
  },
];

export const EDGE_PILLARS = [
  {
    id: "experience",
    title: "Real-World Experience",
    desc: "We've done the work in the field, in the office, and in the trenches.",
  },
  {
    id: "documented",
    title: "Documented Everything",
    desc: "Proof, process, and performance drive every decision.",
  },
  {
    id: "scale",
    title: "Systems That Scale",
    desc: "We build once. We scale forever.",
  },
  {
    id: "growth",
    title: "Growth Without Limits",
    desc: "One mission. Four brands. Unlimited impact.",
  },
];

export const PARENT_TAGLINE = "Building Systems. Raising Standards. Creating Freedom.";
export const HERO_PILLARS = ["Operations", "Accountability", "Growth", "Discipline"];
